export default "/kiban/_next/static/images/searchHover-3fa52ebe17fe40f032bbebfa865bb52e.png";